import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2;
import { observable, action } from 'mobx';
import { mapInitialStateToStoreState } from "../../utils/store.utils/index.js";
// temporary solution for global
// TODO need to delete this row after fixing issue with global
var global = globalThis;

/**
 * Device Rotation Store
 * @Todo this store need to be moved to UI level it's not a business logic and depend on globals
 * @description responsible for detecting landscape mode
 */
var DeviceRotationStore = (_dec = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function DeviceRotationStore(initialState) {
    if (initialState === void 0) {
      initialState = {};
    }
    _initializerDefineProperty(this, "isLandscape", _descriptor, this);
    _initializerDefineProperty(this, "orientationFired", _descriptor2, this);
    this.updateInitialState(initialState);
    global.addEventListener('orientationchange', this.handleOrientationChange.bind(this), false);
    global.addEventListener('resize', this.handleResize.bind(this), false);
    this.updateLandscapeState(); // initial detect
  }
  var _proto = DeviceRotationStore.prototype;
  /**
   * Event Handler
   */
  _proto.handleOrientationChange = function handleOrientationChange() {
    this.orientationFired = true;
  }

  /**
   * Event Handler
   */;
  _proto.handleResize = function handleResize() {
    // resize also fires when soft keyboard shows up without even orientation change
    // to make sure that we get the correct values of width/height, we
    // check if an orientation change was fired and then we get the resize
    if (this.orientationFired) {
      this.updateLandscapeState(); // update observable
      this.orientationFired = false;
    }
  }

  /**
   * method that checks if width > height
   */;
  _proto.detectLandscape = function detectLandscape() {
    return global.innerWidth > global.innerHeight;
  }

  /**
   * update initial state
   * @param {Object} initialState
   */;
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  }

  /**
   * update observable by detecting portrait or landscape mode
   */;
  _proto.updateLandscapeState = function updateLandscapeState() {
    this.isLandscape = this.detectLandscape();
  }

  /**
   * Cleanup and memory release
   * Probably you will call when you want references to be
   * garbage collected
   */;
  _proto.cleanUp = function cleanUp() {
    global.removeEventListener('orientationchange', this.handleOrientationChange.bind(this), false);
    global.removeEventListener('resize', this.handleResize.bind(this), false);
  };
  return DeviceRotationStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isLandscape", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "orientationFired", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLandscapeState", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "updateLandscapeState"), _class.prototype)), _class));
export { DeviceRotationStore as default };